"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryItem = void 0;
const StoryHeader_1 = require("./StoryHeader");
const StoryScreenItem_1 = require("./StoryScreenItem");
class StoryItem extends StoryHeader_1.StoryHeader {
    constructor(data) {
        super(data);
        this.screens = [];
        data = (typeof data === 'string') ? JSON.parse(data) : data;
        this.screens = data.screens.map((s, index) => {
            return new StoryScreenItem_1.StoryScreenItem({
                ...s,
                position: index
            });
        });
    }
}
exports.StoryItem = StoryItem;
//# sourceMappingURL=StoryItem.js.map